import { useSavings } from "../../../composables/savings/useSavings"
import AuthLayout from "../../../components/layouts/auth"
import { useState } from "react";
import { numberWithCommas } from "../../../lib/helper-support";
import TablePagination from "../../../components/table/table-pagination";
import TableSkeleton from "../../../components/loader/table-placeholder-loader";
import Naira from "../../../components/naira";
import { Minus } from "lucide-react";
import moment from "moment";

const Savings = () => {
    const [page, setCurrentPage] = useState<number>(1);
    const { data: savings, isLoading } = useSavings({
        page
    });

    return (
        <AuthLayout>
            <div>
                <div className='items-center justify-between space-y-5 md:flex md:space-y-0'>
                    <div className='flex items-center space-x-6'>
                        <h1 className='page-title'>Savings</h1>
                        <span className='text-tertiary font-[600] text-[14px]'>{numberWithCommas(savings?.total ?? 0)} Savings</span>
                    </div>
                </div>
                <div>
                    {/* table */}
                    <div className='relative overflow-x-auto'>
                        <table className='mt-10 text-tertiary font-[600] text-[14px] w-full relative z-10 whitespace-nowrap'>
                            <thead>
                                <tr className='border-b border-[#E6EAF0]'>
                                    <td className="px-2 py-3">
                                        #
                                        {/* <input type='checkbox' /> */}
                                    </td>
                                    <td className="px-6 py-3">Type</td>
                                    <td className="px-6 py-3">Customer</td>
                                    <td className="px-6 py-3">Status</td>
                                    <td className="px-6 py-3">Goal</td>
                                    <td className="px-6 py-3">Initial Deposit</td>
                                    <td className="px-6 py-3">Amount Saved</td>
                                    <td className="px-6 py-3">Interest Amount</td>
                                    <td className="px-6 py-3">Reocurring Deposit</td>
                                    <td className="px-6 py-3">Next Deposit</td>
                                    <td className="px-6 py-3">Last Deposited</td>
                                    <td className="px-6 py-3">Liquidation Date</td>
                                    <td className="px-6 py-3">Date Created</td>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading && <TableSkeleton numberOfColumns={10} />}
                                {!isLoading && savings?.items?.map((saving: any, index: number) => (
                                    <tr key={index}
                                        className='border-b border-[#E6EAF0] relative'
                                    // style={{ backgroundColor: selectedsavings.includes(saving.reference) ? '#E6EAF0' : '' }}
                                    >
                                        <td className="px-2 py-3">
                                            {index + 1}
                                            {/* <input onChange={(event) => onSelectedsaving(event)} value={saving.reference} type='checkbox' className='relative z-10' /> */}
                                            {/* <Link to={`/savings/${saving.reference}`} className='absolute top-0 bottom-0 left-0 w-full h-full hover:bg-[#E6EAF0] opacity-[0.2]' /> */}
                                        </td>
                                        <td className=" px-6 py-3">
                                            <div className='flex bg-[#ece71b] justify-center w-fit py-2 px-6 rounded-full'>
                                                <span className='first-letter:capitalize'>{saving.savings_type}</span>
                                            </div>
                                        </td>
                                        <td className=" px-6 py-3">{saving.user.display_name ?? <Minus size={14} />}</td>
                                        <td className=" px-6 py-3">
                                            <div className={`flex justify-center w-fit py-2 px-6 rounded-full ${saving.liquidated_at ? 'bg-primary text-white' : 'bg-[#847807] text-white'}`}>
                                                <span className='uppercase text-[11px]'>{saving.liquidated_at ? 'liquidated' : 'active'}</span>
                                            </div>
                                        </td>
                                        <td className="px-6 py-3">{<Naira />} {numberWithCommas(saving.amount_goal, true)}</td>
                                        <td className="px-6 py-3">{<Naira />} {numberWithCommas(saving.initial_deposit, true)}</td>
                                        <td className="px-6 py-3">{<Naira />} {numberWithCommas(saving.amount_saved, true)}</td>
                                        <td className="px-6 py-3">{<Naira />} {numberWithCommas(saving.interest_amount, true)}</td>
                                        <td className="px-6 py-3">
                                            <p>{<Naira />} {numberWithCommas(saving.reoccurring_deposit, true)}</p>
                                            <span className="themeTextMuted">{saving.interval_of_deposit}</span>
                                        </td>
                                        <td className=" px-4 py-3">{moment(saving.next_collection_date).format('h:mm a, MMM D')}</td>
                                        <td className=" px-4 py-3">{moment(saving.last_deposited_date).format('h:mm a, MMM D')}</td>
                                        <td className=" px-4 py-3">{moment(saving.liquidation_date).format('h:mm a, MMM D')}</td>
                                        <td className=" px-4 py-3">{moment(saving.created_at).format('h:mm a, MMM D')}</td>
                                    </tr>
                                ))}

                            </tbody>
                        </table>
                    </div>
                    {/* --/ table */}
                    {/* pagination */}
                    {!isLoading && (
                        <div className='mt-5'>
                            <TablePagination
                                totalPages={savings?.totalPages ?? 0}
                                onPageChange={(page) => setCurrentPage(page)}
                                currentPage={savings?.page}
                            />
                        </div>
                    )}
                    {/* --/ pagination */}
                </div>
            </div>
        </AuthLayout>
    )
}

export default Savings